import React, { useMemo, useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import quotes from './quotes.json';

/**
 * Picks a deterministic index into `quotes` based on today's date, so every
 * visitor sees the same "quote of the day" and it only changes once every 24h.
 */
const getDayIndex = (length) => {
  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 0);
  const diffMs = now - startOfYear;
  const dayOfYear = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return dayOfYear % length;
};

const QuoteOfTheDay = () => {
  const initialIndex = useMemo(() => getDayIndex(quotes.length), []);
  const [index, setIndex] = useState(initialIndex);

  const { quote, author, category } = quotes[index];

  const handleShuffle = () => {
    if (quotes.length <= 1) return;
    let next = index;
    while (next === index) {
      next = Math.floor(Math.random() * quotes.length);
    }
    setIndex(next);
  };

  return (
    <Card className="w-full" >
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center justify-content-between">
          <span className="text-sm font-medium text-color-secondary uppercase">
            Quote of the Day
          </span>
          <i className="pi pi-comment text-2xl text-color-secondary" />
        </div>

        <blockquote className="m-0 text-xl line-height-3" style={{ fontStyle: 'italic' }}>
          "{quote}"
        </blockquote>

        <div className="flex align-items-center justify-content-between">
          <div className="flex align-items-center gap-2">
            <span className="font-semibold">— {author}</span>
            {category && <Tag value={category} severity="info" />}
          </div>
          <Button
            label="New Quote"
            icon="pi pi-refresh"
            text
            size="small"
            onClick={handleShuffle}
          />
        </div>
      </div>
    </Card>
  );
};

export default QuoteOfTheDay;